import React from 'react';
import TagsInputs from './TagsInputs';
import CustomizedSnackbars from '../views/Message';
import ReactHtmlParser from 'react-html-parser';
import Container from '@material-ui/core/Container';
import TagsDelete from './TagsDelete';
import {TagsModalViewViewModel} from './TagsModalViewViewModel';
import {TagsConfigValidator} from '../TagsConfigValidator';

class TagsModal extends React.Component {
    constructor() {
        super();
        this.state = {
            isDisabled: true,
            errorMsg: '',
        };
    }

    handleDisable(data) {
        const validator = new TagsConfigValidator();
        const isValid = validator.validate(data);

        if (isValid) {
            this.setState({isDisabled: false});
        } else {
            this.setState({isDisabled: true});
        }
    }

    handleErrorMsg(message) {
        this.setState({errorMsg: message});
    }

    render() {
        const TagsModalViewModel = new TagsModalViewViewModel(this.props);
        let modalTitle = TagsModalViewModel.modalTitle();
        let modalWidth = TagsModalViewModel.modalWidth();
        let containerClass = TagsModalViewModel.modalContainerClass();

        return (
            <div className={containerClass}>
                <Container component="main" className="p-8" maxWidth={modalWidth}>
                    <div className="tags-modal-title">{modalTitle}</div>
                    <div className="error-message-div">
                        {'' !== this.state.errorMsg && (
                            <CustomizedSnackbars
                                type="error"
                                message={ReactHtmlParser(this.state.errorMsg)}
                            />
                        )}
                    </div>
                    <div>
                        {this.props.modalType !== 'delete' && (
                            <TagsInputs
                                cancelBtn={this.props.cancelBtn}
                                isDisabled={this.state.isDisabled}
                                handleCloseModal={this.props.handleCloseModal}
                                saveRequest={this.props.saveRequest}
                                handleDisable={this.handleDisable.bind(this)}
                                handleErrorMsg={this.handleErrorMsg.bind(this)}
                                row={this.props.row}
                                modalType={this.props.modalType}
                            />
                        )}
                        {this.props.modalType === 'delete' && (
                            <TagsDelete
                                row={this.props.row}
                                cancelBtn={this.props.cancelBtn}
                                handleCloseModal={this.props.handleCloseModal}
                                saveRequest={this.props.saveRequest}
                                handleErrorMsg={this.handleErrorMsg.bind(this)}
                            />
                        )}
                    </div>
                </Container>
            </div>
        );
    }
}

export default TagsModal;
